import React from 'react'

const ViewFiltersButton = (props) => (
  <button
    className="toggle-active toggle sopa-map--panel_view-filter"
    data-toggle="filter"
    onClick={props.handleToggleFilter}
  ><span className="nsw-material-icon material-icons">tune</span><span>Filter</span></button>
)

export default ViewFiltersButton
